module.exports = __webpack_public_path__ + "static/media/btnEnd.c0256fbd.svg";